import {makeCreator} from '~/misc/dispatch';
import types from './types';

export const toastClose = makeCreator(types.TOAST_CLOSE, (uriToast, contextToast) => ({uriToast, contextToast}));

export const toastChange = makeCreator(types.TOAST_CHANGE,
  (uriToast, contextToast) => {
    if (uriToast) {
      return {uriToast, contextToast};
    }
    throw new Error('uriToast should be provided');
  }
);



// WEBPACK FOOTER //
// ./src/modules/toast/actions.js